import { useSlots } from "vue";
import "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import ContentBox from "./ContentBox.js";
import CloseButton from "./CloseButton.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/XIcon-U9bwokTN.js";
import "@fortawesome/vue-fontawesome";
const advancedContentBox = "_advancedContentBox_2z3oe_1";
const header = "_header_2z3oe_10";
const title = "_title_2z3oe_16";
const image = "_image_2z3oe_24";
const text = "_text_2z3oe_28";
const actions = "_actions_2z3oe_33";
const style0 = {
  advancedContentBox,
  header,
  title,
  image,
  text,
  actions
};
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "AdvancedContent",
  inheritAttrs: true
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    title: {
      type: String,
      default: ""
    },
    imageSrc: {
      type: String,
      default: ""
    },
    imageAlt: {
      type: String,
      default: ""
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    ...createTestIdProp()
  },
  emits: [...CloseButton.emits],
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const { formatTestId } = setupTestId(props);
    return { __sfc: true, createTestIdProp, setupTestId, slots, props, formatTestId, ContentBox, CloseButton };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.ContentBox, { class: _vm.$style.advancedContentBox }, [_c("div", { class: _vm.$style.header }, [_c("h5", { class: _vm.$style.title }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm.closeButton ? _c(_setup.CloseButton, { attrs: { "data-testid": _vm.dataTestid }, on: { "close": function($event) {
    return _vm.$emit("close");
  } } }) : _vm._e()], 1), _vm.imageSrc ? _c("img", { class: _vm.$style.image, attrs: { "src": _vm.imageSrc, "alt": _vm.imageAlt, "data-testid": _setup.formatTestId("tooltipImage") } }) : _vm._e(), _c("div", { class: _vm.$style.text }, [_vm._t("default")], 2), _setup.slots.actions ? _c("div", { class: _vm.$style.actions, attrs: { "data-testid": _setup.formatTestId("tooltipActions") } }, [_vm._t("actions")], 2) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const AdvancedContent = __component__.exports;
export {
  AdvancedContent as default
};
